import { useParams } from 'react-router-dom';

import ClinicalNotes from '../../ClinicalNotes';

const ClinicalNotesWrapper = () => {
  const { uuid: patientId } = useParams() as { uuid: string };

  if (!patientId) return <div>No Patient associated with this report.</div>;

  return <ClinicalNotes patientId={patientId} />;
};

export default ClinicalNotesWrapper;
